import React from 'react'
import { Tooltip } from 'antd'
import { segmentApi } from '@edulastic/api'
import { IconPDLSparkle } from '@edulastic/icons'
import { GroupAssignButtonContainer, GroupAssignButton } from './styled'

const GroupAndAssignButton = ({
  onClick,
  disabled = false,
  tooltipText = '',
  source = '',
}) => {
  const handleClick = () => {
    if (onClick && !disabled) {
      segmentApi.genericEventTrack('GroupAndAssign:ButtonClick', { source })
      onClick()
    }
  }

  return (
    <GroupAssignButtonContainer>
      <Tooltip title={tooltipText} placement="left">
        <GroupAssignButton disabled={disabled} onClick={handleClick}>
          <IconPDLSparkle width={24} height={24} />
          <span>Identify Learning Gaps</span>
        </GroupAssignButton>
      </Tooltip>
    </GroupAssignButtonContainer>
  )
}

export default GroupAndAssignButton
